import React from 'react';
import { View, Text } from 'react-native';
import { useTranslation } from 'react-i18next';

import SelectInput from '@preflighttech/preflight-tables/dist/components/inputs/SelectInput';

const LengthMenu = ({ pageLength, updateEntries, options }) => {
  const { t } = useTranslation();

  return (
    <View style={{ flexDirection: 'row', alignItems: 'baseline' }}>
      <Text>{t('table.show')} </Text>
      <SelectInput
        value={pageLength}
        onChange={ value => updateEntries({newPageLength: parseInt(value)}) }
        options={
          options.map(length => {
            return ({ value: parseInt(length) || 0, label: length});
          })
        }
      />
      <Text> {t('table.entries')}</Text>
    </View>
  );
};

export default LengthMenu;
